module.exports = __webpack_public_path__ + "static/media/paymentPage_orderPlaced.cec9cf20.png";